export default __webpack_public_path__ + "static/media/speakers__ish-shabazz.aa7c6aa7.jpg";